import { render, staticRenderFns } from "./userset_safe.vue?vue&type=template&id=1ac6161d"
import script from "./userset_safe.vue?vue&type=script&lang=js"
export * from "./userset_safe.vue?vue&type=script&lang=js"
import style0 from "./userset_safe.vue?vue&type=style&index=0&id=1ac6161d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports